// Mirrors legacy review.js setCookie/getCookie helpers so the
// user-own-review prepend keeps the same persistence semantics:
// cookie expires on the next mid-month boundary (legacy behaviour
// — odd but kept for parity). Persists across browser close,
// shared across SPA pages, no localStorage dependency.

const COOKIE_NAME = 'rev_user';

function nextRotationDate() {
    const d = new Date();
    if (d.getDate() < 15) {
        return new Date(Date.UTC(d.getFullYear(), d.getMonth(), 15, 0, 0, 0));
    }
    return new Date(Date.UTC(d.getFullYear(), d.getMonth() + 1, 1, 0, 0, 0));
}

export function readOwnReview() {
    if (typeof document === 'undefined') return null;
    const raw = (document.cookie || '')
        .split(';')
        .map(s => s.trim())
        .find(s => s.startsWith(COOKIE_NAME + '='));
    if (!raw) return null;
    const value = decodeURIComponent(raw.slice(COOKIE_NAME.length + 1));
    try {
        return JSON.parse(atob(value));
    } catch (_) {
        return null;
    }
}

export function writeOwnReview(payload) {
    if (typeof document === 'undefined') return;
    const expires = nextRotationDate().toUTCString();
    const encoded = btoa(JSON.stringify(payload));
    document.cookie = `${COOKIE_NAME}=${encoded}; expires=${expires}; path=/`;
}
